/* global axios */
import ApiClient from './ApiClient';

class OperatingProcedureRunsAPI extends ApiClient {
  constructor() {
    super('operating_procedure_runs', { accountScoped: true });
  }

  forConversation({ conversationId, operatingProcedureId }) {
    return axios.get(this.url, {
      params: {
        conversation_id: conversationId,
        operating_procedure_id: operatingProcedureId,
      },
    });
  }
}

export default new OperatingProcedureRunsAPI();
